import request from "@/modules/request";

export default class StatsService {
  constructor() {}

  async getAssociateStats(timePeriod) {
    const { results, error } = await request
      .callInternal({
        method: "get",
        route: `/api/stats/?timePeriod=${
          timePeriod.value
        }&localDate=${new Date().toISOString()}`,
      })
      .then((results) => {
        return { results };
      })
      .catch((error) => {
        return { error };
      });

    if (error) {
      console.error(`Error getting stats: ${error}`);
    }

    const {
      totalOrders,
      pendingOrders,
      pending,
      submitted,
      confirmed,
      completed,
      pendingUsers,
      sales,
      margin,
    } = results.data;

    const finalResults = {
      pendingOrders,
      statCards: [],
      pendingUsers,
      pending,
      submitted,
      confirmed,
      completed,
    };

    finalResults.statCards = [
      {
        title: totalOrders,
        subtitle: "Orders",
        icon: "shopping_cart",
        suffix: "Orders",
        color: "primary",
      },
      {
        title: sales,
        subtitle: "Sales",
        suffix: "Sales",
        icon: "monetization_on",
        color: "primary",
      },
    ];

    if (margin) {
      finalResults.statCards.push({
        title: margin,
        subtitle: "Profit",
        suffix: "Profit",
        icon: "thumb_up_alt",
        color: "primary",
      });
    }

    return finalResults;
  }
}
